export default {
  setting: {
    profileAuthSetting: "Profielauthenticatie-instelling",
    logInOutSetting: "Instellingen voor inloggen/uitloggen",
    autoLogout: "Automatisch uitloggen",
    unsuccessfulLoginAttempt: "Mislukte inlogpogingen",
    unsuccessfulLoginLockPeriod:
      "Periode van vergrendeling na mislukte inlogpogingen",
    passCriteriaSetup: "Instellingen voor wachtwoordparameters",
    passLength: "Wachtwoordlengte",
    noUniquePassRequired: "Aantal vereiste unieke wachtwoorden",
    maxPassAge: "Maximale wachtwoordleeftijd",
    acceptableRangeOfChars: "Acceptabel bereik van tekens",
    upperCase: "Hoofdletters",
    lowerCase: "Kleine letters",
    numbers: "Nummers",
    specialChars: "Speciale tekens",
    uniqueSymbols: "Unieke symbolen",
    loadingData: "Gegevens laden...",
    currency: "Valuta",
    codeActivationTime: "Tijd voor activering van de code",
    changeGlobalSetting: "Wijzig globale instelling",
    globalSetting: "Globale instelling",
    generalSetting: "Algemene instelling",
    hours: "Uren",
    days: "Dagen",
    minutes: "Minuten",
    perDay: "Per dag",
    perHour: "Per uur",
    customised: "Aangepast",
    areaUnit: "Oppervlakte-eenheid",
    weightUnit: "Gewichtseenheid",
    minimumPwdLen: "Toegestane minimale wachtwoordlengte",
    smallFarm: "Kleine boerderij",
    inclusive: "Inclusief",
    from: "Van",
    to: "Tot",
    mediumFarm: "Middelgrote boerderij",
    largeFarm: "Grote boerderij",
    requiredMessage: "Dit veld is verplicht",
    nonNegativeMessage: "Dit veld moet niet-negatief zijn",
    fieldToGreaterThanFrom: "Dit veld moet groter zijn dan het veld 'Van'",
    fieldToGreaterThanFromMedium:
      "Dit veld moet groter zijn dan het veld 'Tot' van de kleine boerderij",
    fieldToGreaterThanMediumTo:
      "Dit veld moet groter zijn dan het veld 'Tot' van de middelgrote boerderij",

    farmSettings: "Boerderijinstellingen",
    profileSettings: "Profielinstellingen",
    enterpriseSettings: "Bedrijfsinstellingen",
    coffeeSettings: "Koffieinstellingen",
    cropVarietySettings: "Instellingen voor gewasrassen",
    cropVarietyName: "Naam van het gewasras",
    cropType: "Gewastype",
    addCropVariety: "Nieuw gewasras toevoegen",
    editCropVariety: "Gewasras bewerken",
    deleteCropVariety: "Gewasras verwijderen",
    deleteCropVarietyConfirm: "Weet u zeker dat u dit gewasras wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
    cropVarietyDesc: "Beheer gewasrassen en hun bijbehorende typen voor uw organisatie.",
  },
};
